import styled from 'styled-components';

const BuildingsTemplateStyle = styled.div`
	overflow: hidden;
`;
export default BuildingsTemplateStyle;
